import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Langs from "../../app/lang/langs";
import { formatDate } from "../../app/utils/helpers";
import { SelectInput } from "../../components/inputs/Select";
import { getHolidays, setSelectedYear } from "./settingsSlice";
import styles from "./Settings.module.css";

export default function HolidaysTab({ menuLabel }) {

  const dispatch = useDispatch()

  const settings = useSelector((state) => state.settings)

  const [selectedHolidaysCountry, setSelectedHolidaysCountry] = useState(1)

  function generateYearsOptions() {
    let options = []
    let now = new Date()
    let fromYear = now.getFullYear()
    for (let i = 2022; i < fromYear + 5; i++) {
      now.setFullYear(i)
      options.push({
        value: now.getFullYear(),
        label: now.getFullYear(),
      })
    }
    return options
  }

  const handleYearChange = (option) => {
    dispatch(setSelectedYear(option.value))
    dispatch(getHolidays({ year: option.value }))
  }

  const handleHolidaysCountryChange = (option) => {
    setSelectedHolidaysCountry(option.value)
  }

  function renderHolidaysForSelectedYear() {
    return (
      <Col className={styles.itemsList + " p-2 ps-4 m-0"}>
        <Row className="pt-2 pe-2 m-0">
          <Col xs={6} className="p-0 m-0">
            <label>
              <Langs str="Jours férié" />
            </label>
          </Col>
          <Col xs={6} className="p-0 m-0">
            <label>
              <Langs str="Date" />
            </label>
          </Col>
        </Row>
        {settings.holidays[settings.selectedYear] &&
          settings.holidays[settings.selectedYear][selectedHolidaysCountry] &&
          settings.holidays[settings.selectedYear][selectedHolidaysCountry].map((holiday) => {
            let date = new Date(holiday.date)
            return (
              <Row className={styles.itemLine + " pt-3 pe-2 m-0"}>
                <Col className="p-0 m-0" xs={6}>
                  <span><Langs str={holiday.title} /></span>
                </Col>
                <Col xs={6} className="p-0 m-0">
                  <span>{formatDate(date, "dddd DD MMMM YYYY")}</span>
                </Col>
              </Row>
            )
          })}
      </Col>
    )
  }

  return (
    <Row className="m-0">
      <Col xxl={1}>
      </Col>
      <Col xxl={8} className="d-flex align-content-center">
        <div className={styles.menuContent}>
          <Row className="p-2">
            <Row>
              <Col
                xl={4}
                className="d-flex justify-content-start align-items-center p-2 ps-4">
                <label className={styles.menuHeaderTitle}>
                  <Langs str={menuLabel} />
                </label>
              </Col>
              <Col
                xl={5}
                className="d-flex justify-content-end align-items-center p-2 pe-4">
                <SelectInput
                  value={selectedHolidaysCountry}
                  onChange={handleHolidaysCountryChange}
                  options={settings.countries}
                />
              </Col>
              <Col
                xl={3}
                className="d-flex justify-content-end align-items-center p-2 pe-4">
                <SelectInput
                  value={settings.selectedYear}
                  onChange={handleYearChange}
                  options={generateYearsOptions()}
                />
              </Col>
              {renderHolidaysForSelectedYear()}
            </Row>
          </Row>
        </div>
      </Col>
    </Row>
  )
}
